
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'

export default {
    name: 'UnusualTable',
    props: {
        newsItems: Array,
    },
    methods: {
        numFormat(rate) {
            if (rate !== null) {
                const sign = rate > 0 ? '+' : ''
                let percent = rate / 100
                percent = percent.toFixed(2)
                return sign.concat(percent, '%')
            }
            return '자료없음'
        },
        onClickStock(code) {
            const routeData = this.$router.resolve({
                name: `/stockitem?code=${code}`,
            })
            window.open(
                routeData.location.name,
                'StockItem',
                'width=1200px,height=1000,scrollbars=1,resizable=yes'
            )
        },
    },
}
